import * as React from 'react';
import Svg, { Path, Rect } from 'react-native-svg';
const FilledCheckMarkIcon = props => (
  <Svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <Path
      d="M4.5 21C4.1 21 3.75 20.85 3.45 20.55C3.15 20.25 3 19.9 3 19.5V4.5C3 4.1 3.15 3.75 3.45 3.45C3.75 3.15 4.1 3 4.5 3H19.5C19.9 3 20.25 3.15 20.55 3.45C20.85 3.75 21 4.1 21 4.5V19.5C21 19.9 20.85 20.25 20.55 20.55C20.25 20.85 19.9 21 19.5 21H4.5ZM4.5 19.5H19.5V4.5H4.5V19.5Z"
      fill={props.color || '#1434CB'}
    />
    <Rect x={4} y={4} width={16} height={16} fill={props.color || '#1434CB'} />
    <Path
      d="M10.75 15.6246C10.6667 15.6579 10.575 15.6746 10.475 15.6746C10.375 15.6746 10.2833 15.6579 10.2 15.6246C10.1167 15.5913 10.0333 15.5329 9.95 15.4496L6.975 12.4496C6.825 12.2996 6.75 12.1204 6.75 11.9121C6.75 11.7038 6.825 11.5246 6.975 11.3746C7.125 11.2246 7.30417 11.1538 7.5125 11.1621C7.72083 11.1704 7.89167 11.2413 8.025 11.3746L10.475 13.8246L16.1 8.19961C16.25 8.04961 16.4292 7.97461 16.6375 7.97461C16.8458 7.97461 17.025 8.04961 17.175 8.19961C17.325 8.34961 17.3958 8.53294 17.3875 8.74961C17.3792 8.96628 17.3083 9.14128 17.175 9.27461L11 15.4496C10.9167 15.5329 10.8333 15.5913 10.75 15.6246Z"
      fill={props?.check ?? "white"}
    />
  </Svg>
);
export default FilledCheckMarkIcon;
